import React, { useEffect } from 'react'
import { useAuth } from "./AuthContext";
import { useParams } from "react-router";

export default function GetToken() {
    const { loginSAML } = useAuth();
    const params = useParams();

    useEffect(() => {
        if (!params?.token) return
        const token = decodeURIComponent(params.token)
        loginSAML(token);
    }, [loginSAML, params?.token])
};